<template>
  <div class="license-form-response-holder">
    <div class="license-form-response-container">
      <img
        class="response-close-button"
        width="24"
        height="24"
        v-on:click="closeResponse()"
        :src="require('@/assets/icons/closeicon.svg')"
      />
      <div class="license-form-response">
        <img
          width="64"
          height="64"
          :src="
            statusSuccess
              ? require('@/assets/icons/successicon.svg')
              : require('@/assets/icons/erroricon.svg')
          "
        />
        <div class="license-form-response-title">
          {{ statusSuccess ? "Thank you!" : "Error" }}
        </div>
        <div class="license-form-response-description">
          {{
            statusSuccess
              ? "For signing up to our newsletter!"
              : "An error has occurred, please try again later!"
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    statusSuccess: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    closeResponse() {
      this.$emit('closeResponse');
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/licenseFormResponse.scss";
</style>
